// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__3f4Ye","savePackageButton":"ClientWallet_savePackageButton__2BOge"};